// ----------------------------------------------------------------------------
// Component: Featured Brands
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_featured-brands.scss';